<template>
  <div class="main-container">
    <div class="add-role-title">
      <i class="line"></i>
      <span class="title-text">角色信息</span>
    </div>

    <Form ref="formInline" class="page-form four" :label-width="80" :model="formData">
      <FormItem label="适用机构" prop="roleType" :rules="$units.formRule.required('请选择机构')" class="four" style="width: 450px">
        <RadioGroup v-model="formData.roleType">
          <Radio :label="item.label" disabled v-for="(item, index) in orgList" :key="index">{{ item.name }}</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="自动同步新菜单" :rules="$units.formRule.required('是否自动同步新菜单')" prop="isSyncNew" :label-width="115" style="width: 260px">
        <RadioGroup v-model="formData.isSyncNew">
          <Radio label="1" disabled>是</Radio>
          <Radio label="0" disabled>否</Radio>
        </RadioGroup>
      </FormItem>
    </Form>

    <div class="add-role-title spacing">
      <i class="line"></i>
      <span class="title-text">菜单权限</span>
      <div class="text-1">查看：是否展示菜单给此角色</div>
      <div class="text-2">查看敏感数据：是否展示完整信息（姓名、手机号、证件号、地址、邮箱）给此角色</div>
    </div>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="page-body">
      <div class="table-page">
        <div class="rate-table">
          <div class="head">
            <div class="td first-td td-p">
              <div class="name-key">一级菜单</div>
            </div>
            <div class="td td-p">二级菜单</div>
            <div class="td td-p">三级菜单</div>
            <div class="td last-td td-p">功能点</div>
          </div>

          <div class="body">
            <div class="empty-text" v-if="tableData.length == 0">暂无数据</div>

            <div class="row-child" v-for="(item, x) in tableData" :key="x">
              <div class="head">
                <div class="td">
                  <span class="name-key-01">
                    <div class="seat-dom"></div>
                    <Checkbox :disabled="true" :true-value="1" :false-value="0" v-model="item.isExist">{{ item.name }}</Checkbox>
                  </span>

                  <div class="td-2-box">
                    <div v-for="(item2, x2) in item.childs" :key="x2" class="td-2" :class="item.childs.length == x2 + 1 ? 'no-data' : ''">
                      <span class="name-key-02">
                        <Checkbox :disabled="true" v-if="!item2.web && item2.name" :true-value="1" :false-value="0" v-model="item2.isExist">{{
                          item2.name
                        }}</Checkbox>
                      </span>

                      <div class="td-3-box">
                        <div v-for="(item3, x3) in item2.childs" :key="x3" class="td-3" :class="item2.childs.length == x3 + 1 ? 'no-data' : ''">
                          <span class="name-key-03">
                            <Checkbox :disabled="true" v-if="!item3.web && item3.name" :true-value="1" :false-value="0" v-model="item3.isExist">{{
                              item3.name
                            }}</Checkbox>
                          </span>
                          <div class="td-4-box" v-if="item2.perms">
                            <div v-for="(item4, x4) in item2.perms" :key="x4" class="td-4">
                              <span
                                class="name-key-04"
                                :class="{ 'see-2': item4.name == '查看', 'see-1': item4.name == '查看敏感数据' || item4.isSensitive == '1' }"
                              >
                                <Checkbox :disabled="true" :true-value="1" :false-value="0" v-model="item4.isExist">
                                  {{ item4.name }}
                                </Checkbox>
                              </span>
                            </div>
                          </div>
                          <div class="td-4-box" v-else>
                            <div v-for="(item4, x4) in item3.perms" :key="x4" class="td-4">
                              <span
                                class="name-key-04"
                                :class="{ 'see-2': item4.name == '查看', 'see-1': item4.name == '查看敏感数据' || item4.isSensitive == '1' }"
                              >
                                <Checkbox :disabled="true" :true-value="1" :false-value="0" v-model="item4.isExist">
                                  {{ item4.name }}
                                </Checkbox>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="td-3-box" v-if="!item2.childs.length">
                        <div class="td-3 no-data">
                          <span class="name-key-03"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
export default {
  components: { selectTree },
  data() {
    return {
      formData: {
        roleType: ''
      },
      tableData: [],
      id: '',
      orgList: [
        {
          label: '1',
          name: '本机构'
        },
        {
          label: '2',
          name: '省级机构'
        },
        {
          label: '3',
          name: '市级机构'
        },
        {
          label: '4',
          name: '区级机构'
        },
        {
          label: '6',
          name: '营业部'
        }
      ]
    };
  },

  async created() {
    if (this.formData.roleType != 1) {
      this.orgList.splice(0, 1);
    }
    this.id = this.$route.query.id;
    await this.queryFormDetail();
    this.queryData();
  },

  methods: {
    queryData() {
      this.$http({
        url: '/buz/rolesExt/menuPerms',
        type: 'POST',
        data: {
          menuType: '2',
          roleType: this.formData.roleType,
          roleIds: this.id && this.id.split(',')
        }
      }).then(res => {
        this.tableData = this.recursionDataVal(res.data);
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 回显
    recursionDataVal(arr) {
      // 第一级菜单
      arr.map((item2, index2) => {
        // 处理二级菜单
        if (!item2.childs.length) {
          item2.childs = [
            {
              id: item2.id + '' + (index2 + 1),
              level: 2,
              name: '-',
              childs: [],
              web: true
            }
          ];
        }
        item2.isExist = this.id && !item2.isExist ? 0 : 1;

        // 处理三级菜单
        item2.childs.map((item3, index3) => {
          // 处理二级菜单
          if (!item3.childs.length) {
            item3.childs = [
              {
                id: item3.id + '' + (index3 + 1),
                level: 3,
                name: '-',
                childs: [],
                web: true
              }
            ];
          }

          // 回显二级菜单
          item3.isExist = this.id && !item3.isExist ? 0 : 1;

          item3.childs.map(item4 => {
            item4.childs = item3.perms || item4.perms || [];
            // 回显三级菜单
            item4.isExist = this.id && !item4.isExist ? 0 : 1;

            item4.childs.map(item5 => {
              // 回显功能点
              item5.isExist = this.id && !item5.isExist ? 0 : 1;
            });
          });
        });
      });
      return arr;
    },

    queryFormDetail() {
      return this.$http({
        url: '/buz/rolesExt/queryDetailByIds',
        type: 'POST',
        data: this.id.split(',')
      }).then(res => {
        this.formData.isSyncNew = res.data.isSyncNew;
        this.formData.roleType = res.data.roleType && res.data.roleType + '';
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './roleAuthority.scss';
</style>
